import {useTranslation} from 'react-i18next';
import Loader from "../../common/simple/loader";
import {Modal, Row} from 'react-bootstrap';
import {StyledModal} from '../shared/modal.styled';


export default function GeneralPopUp({show, onHideModal, className, containerClasses, title, text}) {
    const {t} = useTranslation();
    return (
        <StyledModal
            centered
            className={containerClasses}
            dialogClassName={['general-modal', className]}
            show={show}
            onHide={onHideModal}
        >
             <span
                 className={'modal-close'}
                 onClick={onHideModal}
             >
                &#215;
            </span>
            <Modal.Header>
                <Modal.Title>{title || t('titles.general_pop_up_title')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Loader/>
                <Row className={'justify-content-center'}>
                    <h3>{text}</h3>
                </Row>
            </Modal.Body>
        </StyledModal>
    );
}

